import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Table } from 'primeng/table';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { MeasureService } from 'src/app/appServices/MeasureService/measureService.service';
import { LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { Workbook } from 'exceljs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {
  audioOnlyList,
  caseTypeOptions,
  doortoNeedleTimeOptions,
  eAlertOptions,
  folowUpList,
  qpsReviewOptions,
  selectWorkFlowTypeOptions,
  spokeWithList,
  statusList,
  thrombolyticsOptions,
  timeFameList,
  typeOfCorrespondence,
} from 'src/app/appWeb/shared/shared';
import { facilitySystemList } from 'src/app/appWeb/shared/shared-interface';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';

interface cases {
  CASEIdentificatinNumber: string | null;
  CASEIdentificationTYPE: string | null;
  CASENumber: number | null;
  CaseKey: number | null;
  CaseStartTime: string | null;
  CaseStatus: number | null;
  CaseType: string | null;
  FacilityName: string | null;
  PatientDOB: string | null;
  PatientName: string | null;
  PhysicianName: string | null;
  QPSReviewCompleted: number | null;
  totalRecords: number | null;
}
interface physicionList {
  Id: string | null;
  Name: string | null;
}
interface getFollowupDataForCaseValues {
  TimeZone?: string | null;
  cas_metric_has_morbid_symptoms?: number | null;
  cas_premorbid_approved_for_quote?: boolean;
  cas_premorbid_completed_by?: string | null;
  cas_premorbid_completed_date?: string | null;
  cas_premorbid_contact_person_name?: string | null;
  cas_premorbid_fac_contact_name?: string | null;
  cas_premorbid_fac_satisfaction_notes?: string | null;
  cas_premorbid_symptoms?: number | null;
  cas_premorbid_symptoms_text?: string | null;
}
interface qPSListValues {
  Disabled: boolean;
  Group: string | null;
  Selected: boolean;
  Text: string | null;
  Value: string | null;
}

@Component({
  selector: 'app-measures',
  templateUrl: './measures.component.html',
  styleUrls: ['./measures.component.scss'],
})
export class MeasuresComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  @ViewChild('dt') quarter: Table | undefined;
  cases: Array<cases> = [];
  advanceFormSearch!: FormGroup;
  totalRecords: number = 0;
  pageNumber: number = 1;
  rows: number = 15;
  sortOrder: string = 'DESC';
  sortCol: string = '';
  filterVal: string = '';
  cols: any;
  showProgressSpinner: boolean = false;
  noRecordBool = false;
  EditScreenBool: boolean = false;
  currentDate: string = '';
  currentTime!: string | null;
  form!: FormGroup;
  typeOfCorrespondence = typeOfCorrespondence;
  audioOnlyList = audioOnlyList;
  audioOnly: string = '';
  casIsFlaggedList = audioOnlyList;
  casIsFlagged: any;
  statusList = statusList;
  status: Array<string> = [];
  folowUpList = folowUpList;
  timeFameList = timeFameList;
  timeFrame: string = 'Last48Hours';
  folowUp: string = '';
  searchField: any = '';
  editCaseData: any;
  spokeWithList = spokeWithList;
  facilityList: Array<facilitySystemList> = [];
  selectedFacility: Array<string> = [];
  physicionList: Array<physicionList> = [];
  selectedPhysicion: Array<string> = [];
  disablePhysicion: boolean = true;
  event: any = '';
  toastType: string = '';
  caseKey: number = 0;
  unSuccessfullBool: boolean = false;
  firstUnsuccessfull: boolean = false;
  secondUnsuccessfull: boolean = false;
  thirdUnsuccessfull: boolean = false;
  userName: string | null = '';
  cas_premorbid_approved_for_quote_bool: boolean = false;
  getFollowupData: any;
  pmc_cas_willing_todo_interview_bool: boolean = false;
  getFollowupDataForCaseValues!: getFollowupDataForCaseValues;
  qPSListValues: Array<qPSListValues> = [];
  cas_metric_has_morbid_symptoms: number | null | undefined;

  UId: string | null = '';
  userID_1: string | null = '';
  userID_2: string | null = '';
  userID_3: string | null = '';
  userID_4: string | null = '';
  caseStatus: any;
  showSaveBool: boolean = false;
  selectedTeleneuro_QPS: Array<string> = [];
  onClickDisable: boolean = false;
  txtStartDate: string | null = '';
  txtEndDate: string | null = '';
  txtSpecificDate: string | null = '';
  showStartEndDateBool: boolean = false;
  showDateBool: boolean = false;
  loading = [false, false, false, false];
  datePipe = new DatePipe('en-US');
  data = {};
  timeZone: string = '';
  ReviewOnEst: boolean = false;
  accessCase: string = '';
  viewCaseReview: any;
  isReadonly: boolean = false;
  roleAccessResult: any = [];
  isAccessReadWrite: boolean = false;
  isAccessRead: boolean = false;
  teleUrl: string = environment.teleUrl;
  RoleName: string | null = '';
  caseHeaderName: string = '';

  txtStartDateErrorBool: boolean = false;
  txtEndDateErrorBool: boolean = false;
  txtSpecificDateErrorBool: boolean = false;
  textStrtColorBool: boolean = false;
  textEndColorBool: boolean = false;
  specificDatecolorBool: boolean = false;
  dateRangeBool: boolean = false;
  selectWorkFlowTypeOptions = selectWorkFlowTypeOptions;
  // work_flow_type: any = [];
  thrombolyticsOptions = thrombolyticsOptions;
  thrombolytics: string = '';
  clearSearchBool: boolean = false;
  excelBool: boolean = false;
  exportExcelLoader: boolean = false;
  advanceSearchModal: boolean = false;
  advanceSearchLoader: boolean = false;
  caseTypeOptions = caseTypeOptions;
  eAlertOptions = eAlertOptions;
  Teleneuro_QPS: Array<facilitySystemList> = [];
  qpsReviewOptions = qpsReviewOptions;
  qpsReviewCompleted: string = '';
  doortoNeedleTimeOptions = doortoNeedleTimeOptions;
  doortoNeedleTime: string = '';
  editScreen: boolean = false;
  private subscription: Subscription[] = [];
  SelectedCaseEdit: any = [];
  toolTip!: string;
  roleForFacility: boolean = false;
  showToast: boolean = false;
  minDate = new Date();
  crossSearchBool: boolean = false;
  cas_case_type: any = [];
  bool1: boolean = false;

  constructor(
    public analyzeService: AnalyzeService,
    public fb: FormBuilder,
    public measureService: MeasureService,
    private helperService: HelperService,
    private messageService: MessageService,
    private Observable: ObservableService,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    private accessControlService: AccessControlService
  ) {
    this.EditScreenBool = false;
  }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(
      localStorage.getItem(LocalStorage.UId)
    );
    this.RoleName = this.helperService.decryption(
      localStorage.getItem(LocalStorage.UserRoleName)
    );
    this.userName = this.helperService.decryption(
      localStorage.getItem(LocalStorage.UserFullName)
    );
    this.roleForFacility = this.authService.roleForFacility();
    this.advanceSearchForm();
    this.createForm();
    this.minDate = this.analyzeService.CalanderDateRangeSelection(
      this.roleForFacility
    );
    this.subscription.push(
      this.route.queryParamMap.subscribe((params: any) => {
        if (Boolean(params.get('getCaseDetail'))) {
          const getCase = params.get('getCaseDetail');
          const getCaseDetail = Boolean(getCase);
          const edit = params.get('editScreen');
          this.editScreen = Boolean(edit);
          const caseKey = params.get('caseKey');
          const caseStatus = params.get('caseStatus');
          const caseStartTime = params.get('caseStartTime');
          const screenStatus = params.get('screenStatus');
          const SelectedCaseEdit = JSON.parse(params.get('SelectedCaseEdit'));
          const data = {
            CaseKey: caseKey,
            CaseStatus: caseStatus,
            CaseStartTime: caseStartTime,
            CASENumber: SelectedCaseEdit?.CASENumber,
          };
          if (getCaseDetail && screenStatus == 'Edit') {
            this.isReadonly = false;
            this.cases.push(SelectedCaseEdit);
            this.getElementByFollowUp(data);
          } else if (getCaseDetail && screenStatus == 'View') {
            this.isReadonly = true;
            this.cases.push(SelectedCaseEdit);
            this.Viewcasereview(data);
          }

          if (this.editScreen) {
            this.EditScreenBool = true;
            this.CheckRoleAccess();
          }
          this.analyzeService.ClearQueryParams();
        }
      })
    );
    this.getAllFacility();
  }

  ngAfterContentInit(): void {
    if (!this.editScreen) {
      this.subscription.push(
        this.Observable.value$.subscribe((val) => {
          this.EditScreenBool = val;
          this.searchField = '';
        })
      );
    }
  }

  checkEmptyFields() {
    if (
      this.audioOnly == '' &&
      this.audioOnly == null &&
      this.folowUp == '' &&
      this.folowUp == null &&
      this.status == null &&
      this.timeFrame == '' &&
      this.timeFrame == null &&
      this.searchField == '' &&
      this.searchField == null &&
      this.txtSpecificDate == '' &&
      this.txtSpecificDate == null &&
      this.txtStartDate == '' &&
      this.txtStartDate == null &&
      this.txtEndDate == '' &&
      this.txtEndDate == null &&
      this.casIsFlagged == '' &&
      this.casIsFlagged == null
    ) {
      this.data = {
        Take: this.excelBool ? 0 : this.rows,
        Skip: this.excelBool ? 0 : this.rows * this.pageNumber - this.rows,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        searchString: this.searchField.trim(),
        PageNumber: this.pageNumber,
        serviceType: [],
        roleIDs: [''],
        Filters: [],
      };
    } else {
      let advance_date: any;
      if (this.advanceFormSearch.controls['cas_advance_date'].value) {
        advance_date = this.datePipe.transform(
          this.advanceFormSearch.controls['cas_advance_date'].value,
          'MM/dd/yyyy'
        );
      }
      if (this.advanceFormSearch.controls['folowUp'].value != null) {
        if (this.advanceFormSearch.controls['folowUp'].value.length > 0) {
          this.folowUp = this.advanceFormSearch.controls['folowUp'].value[0];
        }
      }
      if (this.timeFrame === '-1') {
        this.txtEndDate = new Date().toDateString();
        this.txtStartDate = this.analyzeService
          .CalanderDateRangeSelection(this.roleForFacility)
          .toDateString();
      }
      this.data = {
        Take: this.excelBool ? 0 : this.rows,
        Skip: this.excelBool ? 0 : this.rows * this.pageNumber - this.rows,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        searchString: this.searchField.trim(),
        PageNumber: this.pageNumber,
        serviceType: [],
        roleIDs: [''],
        Filters: [
          {
            FieldName: 'cas_is_audio_consult',
            value: this.audioOnly,
          },
          {
            FieldName: 'cas_is_flagged',
            value: this.casIsFlagged,
          },
          {
            FieldName: 'cas_status',
            value: this.status.toString(),
          },
          {
            FieldName: 'date_filter',
            value: this.timeFrame == '-1' ? 'DateRange' : this.timeFrame,
          },
          {
            FieldName: 'search_text',
            value: this.searchField.trim(),
          },
          {
            FieldName: 'specific_date',
            value: this.txtSpecificDate,
          },
          {
            FieldName: 'start_date',
            value: this.txtStartDate,
          },
          {
            FieldName: 'end_date',
            value: this.txtEndDate,
          },
          {
            FieldName: 'cas_case_number',
            value: this.advanceFormSearch.controls['cas_case_number'].value,
          },
          {
            FieldName: 'cas_case_type',
            value: this.cas_case_type ? this.cas_case_type.toString() : null,
          },
          {
            FieldName: 'cas_patient',
            value: this.advanceFormSearch.controls['cas_patient'].value,
          },
          {
            FieldName: 'cas_advance_date',
            value: advance_date,
          },
          {
            FieldName: 'advance_cas_billing_visit_type',
            value: this.folowUp
              ? this.folowUp
              : this.advanceFormSearch.controls['folowUp'].value
              ? this.advanceFormSearch.controls['folowUp'].value.toString()
              : null,
          },
          {
            FieldName: 'CASEIdentificatinNumber',
            value:
              this.advanceFormSearch.controls['CASEIdentificatinNumber'].value,
          },
          {
            FieldName: 'physcianIDs',
            value: this.advanceFormSearch.controls['selectedPhysicion'].value
              ? this.advanceFormSearch.controls[
                  'selectedPhysicion'
                ].value.toString()
              : null,
          },
          {
            FieldName: 'cas_eAlert',
            value: this.advanceFormSearch.controls['cas_eAlert'].value
              ? this.advanceFormSearch.controls['cas_eAlert'].value.toString()
              : null,
          },
          {
            FieldName: 'ThrombolyticFilter',
            value: this.thrombolytics ? this.thrombolytics.toString() : null,
          },
          {
            FieldName: 'TeleQPSFilter',
            value: this.selectedTeleneuro_QPS
              ? this.selectedTeleneuro_QPS.toString()
              : null,
          },
          {
            FieldName: 'facilityIDs',
            value: this.selectedFacility
              ? this.selectedFacility.toString()
              : null,
          },
          {
            FieldName: 'QPSReviewCompleted',
            value: this.qpsReviewCompleted
              ? this.qpsReviewCompleted.toString()
              : null,
          },
          {
            FieldName: 'DoortoNeedle',
            value: this.doortoNeedleTime
              ? this.doortoNeedleTime.toString()
              : null,
          },
        ],
        data: {
          PatientType: this.advanceFormSearch.controls['work_flow_type'].value
            ? this.advanceFormSearch.controls['work_flow_type'].value
            : [],
        },
      };
      if (this.timeFrame == 'DateRange') {
        if (this.txtStartDate == null) {
          this.txtStartDateErrorBool = true;
        } else {
          this.txtStartDateErrorBool = false;
        }
        if (this.txtEndDate == null) {
          this.txtEndDateErrorBool = true;
        } else {
          this.txtEndDateErrorBool = false;
        }
        if (this.txtStartDate != null && this.txtEndDate != null) {
          let txtStartDate = new Date(this.txtStartDate);
          let txtEndDate = new Date(this.txtEndDate);
          if (txtStartDate > txtEndDate) {
            this.dateRangeBool = true;
          } else {
            this.dateRangeBool = false;
          }
        }
      } else {
        this.txtStartDateErrorBool = false;
        this.txtEndDateErrorBool = false;
        this.dateRangeBool = false;
      }

      if (this.timeFrame == 'SpecificDate') {
        if (this.txtSpecificDate == null) {
          this.txtSpecificDateErrorBool = true;
        } else {
          this.txtSpecificDateErrorBool = false;
        }
      } else {
        this.txtSpecificDateErrorBool = false;
      }
    }
  }

  getAllCases(value: any, advanceSearchLoader: any) {
    this.excelBool = false;
    if (
      value == 'audioOnly' ||
      value == 'status' ||
      value == 'followUp' ||
      value == 'flag' ||
      value == 'qps' ||
      value == 'thrombolytics' ||
      value == 'qpsReview' ||
      value == 'doortoNeedleTime' ||
      value == 'caseType' ||
      value == 'facilityIDs' ||
      value == 'advance'
    ) {
      this.rows = 15;
      this.pageNumber = 1;
      this.clearSearchBool = true;
      this.advanceFormSearch.patchValue({ folowUp: [] });
    }
    if (value == 'search-btn') {
      this.clearSearchBool = true;
    }
    this.txtSpecificDate = this.datePipe.transform(
      this.txtSpecificDate,
      'MM/dd/yyyy'
    );
    this.txtStartDate = this.datePipe.transform(
      this.txtStartDate,
      'MM/dd/yyyy'
    );
    this.txtEndDate = this.datePipe.transform(this.txtEndDate, 'MM/dd/yyyy');
    this.checkEmptyFields();

    this.advanceSearchLoader = advanceSearchLoader;

    if (
      this.txtStartDateErrorBool == false &&
      this.txtEndDateErrorBool == false &&
      this.txtSpecificDateErrorBool == false &&
      this.dateRangeBool == false
    ) {
      if (advanceSearchLoader == false) {
        this.showProgressSpinner = true;
      }

      this.subscription.push(
        this.analyzeService
          .getAllCases(this.RoleName, this.UId, this.data)
          .subscribe({
            next: (res: any) => {
              if (this.advanceSearchLoader == true) {
                this.advanceSearchLoader = false;
              }
              if (res.data.length == 0) {
                this.noRecordBool = true;
              } else {
                this.noRecordBool = false;
              }
              if (res) {
                this.cases = res.data;
                if (this.cases.length > 0) {
                  this.cases.forEach((item: any) => {
                    let caseStatus = this.statusList.filter((x: any) => {
                      return x.value == item.CaseStatus;
                    });
                    if (caseStatus.length > 0) {
                      item.caseStatusLabel = caseStatus[0].name;
                    }
                  });
                }
                this.cases.forEach((element: any) => {
                  element.CASEIdentificationTYPE =
                    element?.CASEIdentificationTYPE?.concat(':').concat(
                      element?.CASEIdentificatinNumber != null
                        ? element?.CASEIdentificatinNumber
                        : 'N/A'
                    );
                  if (element.CaseStartTime == '1900-01-01T00:00:00') {
                    element.CaseStartTime = '';
                  }
                });
                this.advanceSearchModal = false;
                if (value == 'advance' || value == 'search-btn') {
                  this.clearSearchBool = true;
                }
                this.totalRecords = res.Total;
                if (this.showProgressSpinner == true) {
                  this.showProgressSpinner = false;
                }
                this.analyzeService.currentDateTime();
                this.CheckRoleAccess();
              }
            },
            error: (err: any) => {},
          })
      );
    } else {
      if (this.txtStartDateErrorBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Start Date first.',
        });
        this.textStrtColorBool = true;
        setTimeout(() => {
          this.textStrtColorBool = false;
        }, 1000);
        return;
      }
      if (this.txtEndDateErrorBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select End Date first.',
        });
        this.textEndColorBool = true;
        setTimeout(() => {
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
      if (this.txtSpecificDateErrorBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Date first.',
        });
        this.specificDatecolorBool = true;
        setTimeout(() => {
          this.specificDatecolorBool = false;
        }, 1000);
        return;
      }
      if (this.dateRangeBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'End Date should be greater than Start Date.',
        });
        // this.textStrtColorBool = true;
        this.textEndColorBool = true;
        setTimeout(() => {
          // this.textStrtColorBool = false;
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
    }
  }
  CheckRoleAccess() {
    const accessData = this.accessControlService.checkAccess(
      MenuItemsAccess.CaseFollowUpRead,
      MenuItemsAccess.CaseFollowUpReadWrite
    );
    this.isAccessRead = accessData.isAccessRead;
    this.isAccessReadWrite = accessData.isAccessReadWrite;

    this.isAccessReadWrite && !this.roleForFacility
      ? (this.toolTip = 'Double Click to Edit')
      : (this.toolTip = 'Double Click to View');
  }

  toolTipOption(cases: string): string {
    return cases == 'Stroke Alert' || cases == 'STAT Consult'
      ? this.toolTip
      : '';
  }

  ClearSearch() {
    if (this.selectedFacility.length > 0) {
      this.selectedFacility = [];
    }
    if (this.selectedPhysicion.length > 0) {
      this.selectedPhysicion = [];
    }

    if (this.selectedTeleneuro_QPS.length > 0) {
      this.selectedTeleneuro_QPS = [];
    }
    if (this.cas_case_type.length > 0) {
      this.cas_case_type = [];
    }
    this.doortoNeedleTime = '';
    this.qpsReviewCompleted = '';

    this.thrombolytics = '';
    this.audioOnly = '';
    this.folowUp = '';
    this.timeFrame = 'Last48Hours';
    this.casIsFlagged = '';
    this.searchField = '';
    this.filterVal = '';
    this.advanceFormSearch.reset();
    if (this.txtSpecificDate) {
      this.txtSpecificDate = '';
      this.showDateBool = false;
    }
    if (this.txtStartDate || this.txtEndDate) {
      this.txtStartDate = '';
      this.txtEndDate = '';
      this.showStartEndDateBool = false;
    }
    this.clearSearchBool = false;
    this.crossSearchBool = false;
    if (this.status.length > 0) {
      this.status = [];
    }
    this.getAllCases('', false);
  }
  onChangeTimeFrame(event: any) {
    if (event.value == this.timeFameList[10].value) {
      this.showStartEndDateBool = true;
    } else {
      this.showStartEndDateBool = false;
    }
    if (event.value == this.timeFameList[9].value) {
      this.showDateBool = true;
    } else {
      this.showDateBool = false;
    }
    this.rows = 15;
    this.pageNumber = 1;
    if (
      event.value != this.timeFameList[10].value &&
      event.value != this.timeFameList[9].value
    ) {
      this.clearSearchBool = true;
      this.getAllCases('', false);
    }
  }
  getAllFacility() {
    this.subscription.push(
      this.analyzeService.GetFacilityPIList(this.RoleName, this.UId).subscribe({
        next: (res: any) => {
          if (res) {
            this.facilityList = res?.Facilities;
            this.Teleneuro_QPS = res?.QPSList;
          }
        },
        error: (err: any) => {},
      })
    );
  }
  GetFacilityPhysicion() {
    if (this.physicionList && this.physicionList.length > 0) {
      return; 
    }
    if (this.selectedFacility.length > 0) {
      this.physicionList = [];
      this.selectedPhysicion = [];
      this.subscription.push(
        this.analyzeService
          .GetFacilityPhysician(this.selectedFacility)
          .subscribe({
            next: (res: any) => {
              if (res) {
                this.physicionList = res?.data;
              }
            },
            error: (err: any) => {},
          })
      );
    } else {
      this.physicionList = [];
      this.selectedPhysicion = [];
      var facility: any = [];
      this.subscription.push(
        this.analyzeService.GetFacilityPhysician(facility).subscribe({
          next: (res: any) => {
            if (res) {
              this.physicionList = res?.data;
            }
          },
          error: (err: any) => {},
        })
      );
    }
  }
  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1
          ? 'DESC'
          : 'ASC';
      this.sortCol =
        event.multiSortMeta == undefined ? '' : event.multiSortMeta[0].field;
      this.searchField.length > 0
        ? (this.crossSearchBool = true)
        : (this.crossSearchBool = false);
      this.getAllCases('', false);
    }
  }
  Accesscase(data: any) {
    if (data == '') {
      this.caseKey;
    } else {
      this.caseKey = data.CaseKey;
    }
    this.accessCase =
      this.teleUrl + `Case/Edit/${this.caseKey}?showPopupOnLoad=true`;
    window.open(this.accessCase);
  }

  getCaseDetailByDoubleClick(cases: any) {
    if (cases.CaseType == 'Stroke Alert' || cases.CaseType == 'STAT Consult') {
      let bool: any;
      this.isAccessReadWrite && !this.roleForFacility
        ? (bool = false)
        : (bool = true);
      this.getElementByFollowUp(cases, bool);
    }
  }

  Viewcasereview(data: any) {
    this.getElementByFollowUp(data, true);
  }

  getElementByFollowUp(followUpId: any, isReadOnly: boolean = false) {
    this.ReviewOnEst = false;
    this.SelectedCaseEdit = [];
    this.isReadonly = isReadOnly;
    this.EditScreenBool = true;
    this.caseKey = followUpId.CaseKey;
    this.accessCase =
      this.teleUrl + `Case/Edit/${this.caseKey}?showPopupOnLoad=true`;
    this.caseStatus = followUpId.CaseStatus;
    this.showProgressSpinner = true;
    this.SelectedCaseEdit = this.cases.filter(
      (a: any) => a.CASENumber == followUpId.CASENumber
    );
    this.caseHeaderName = 'Edit Case Follow Up';
    if (isReadOnly == true) {
      this.caseHeaderName = 'View Case Follow Up';
    }
    this.form.reset();
    this.subscription.push(
      this.measureService.GetFollowUpData(this.caseKey).subscribe({
        next: (res: any) => {
          this.getFollowupData = res.PremorbidData;
          this.getFollowupDataForCaseValues = res.CaseData[0];
          this.qPSListValues = res.QPSList;
          this.timeZone = res.timeZone;
          this.form.patchValue({
            pmc_cas_premorbid_patient_phone:
              this.getFollowupData.pmc_cas_premorbid_patient_phone,
            pmc_cas_patient_satisfaction_video_experience:
              this.getFollowupData
                .pmc_cas_patient_satisfaction_video_experience,
            pmc_cas_patient_satisfaction_communication:
              this.getFollowupData.pmc_cas_patient_satisfaction_communication,
            pmc_cas_patient_satisfaction_overall:
              this.getFollowupData.pmc_cas_patient_satisfaction_overall,
            pmc_cas_willing_todo_interview:
              this.getFollowupData.pmc_cas_willing_todo_interview,
            pmc_cas_consent_sent: this.getFollowupData.pmc_cas_consent_sent,
            pmc_cas_consent_received:
              this.getFollowupData.pmc_cas_consent_received,

            pmc_cas_premorbid_successful_or_unsuccessful_first:
              this.getFollowupData
                .pmc_cas_premorbid_successful_or_unsuccessful_first,
            pmc_cas_premorbid_successful_or_unsuccessful_second:
              this.getFollowupData
                .pmc_cas_premorbid_successful_or_unsuccessful_second,
            pmc_cas_premorbid_successful_or_unsuccessful_third:
              this.getFollowupData
                .pmc_cas_premorbid_successful_or_unsuccessful_third,
            pmc_cas_premorbid_successful_or_unsuccessful_fourth:
              this.getFollowupData
                .pmc_cas_premorbid_successful_or_unsuccessful_fourth,

            cas_premorbid_symptoms:
              this.getFollowupDataForCaseValues.cas_premorbid_symptoms,
            cas_premorbid_completed_by:
              this.getFollowupDataForCaseValues.cas_premorbid_completed_by,
            cas_premorbid_completed_date: this.datePipe.transform(
              this.getFollowupDataForCaseValues.cas_premorbid_completed_date,
              'MM/dd/yyyy HH:mm:ss'
            ),
            cas_premorbid_symptoms_text:
              this.getFollowupDataForCaseValues.cas_premorbid_symptoms_text,
            cas_premorbid_fac_satisfaction_notes:
              this.getFollowupDataForCaseValues
                .cas_premorbid_fac_satisfaction_notes,
            cas_premorbid_fac_contact_name:
              this.getFollowupDataForCaseValues.cas_premorbid_fac_contact_name,
            cas_premorbid_approved_for_quote:
              this.getFollowupDataForCaseValues
                .cas_premorbid_approved_for_quote,
            cas_premorbid_contact_person_name:
              this.getFollowupDataForCaseValues
                .cas_premorbid_contact_person_name,
            pmc_cas_final_attempt: this.getFollowupData.pmc_cas_final_attempt,
          });
          if (this.getFollowupData.pmc_cas_final_attempt) {
            this.thirdUnsuccessfull = true;
          } else {
            this.thirdUnsuccessfull = false;
          }
          if (this.getFollowupDataForCaseValues.cas_premorbid_completed_date) {
            this.ReviewOnEst = true;
          }
          this.cas_metric_has_morbid_symptoms =
            this.getFollowupDataForCaseValues.cas_metric_has_morbid_symptoms;

          if (
            this.getFollowupData
              .pmc_cas_premorbid_successful_or_unsuccessful_first == 2
          ) {
            this.firstUnsuccessfull = false;
          } else {
            this.firstUnsuccessfull = true;
          }
          if (
            this.getFollowupData
              .pmc_cas_premorbid_successful_or_unsuccessful_second == 2
          ) {
            this.secondUnsuccessfull = false;
          } else {
            this.secondUnsuccessfull = true;
          }

          if (this.getFollowupData.pmc_cas_premorbid_completedby != null) {
            for (
              var i = 0;
              i < this.getFollowupData.pmc_cas_premorbid_completedby.length;
              i++
            ) {
              var checkdate =
                this.getFollowupData.pmc_cas_premorbid_datetime_of_contact[i];
              if (checkdate != '' || checkdate != undefined) {
                if (i == 0) {
                  this.form.patchValue({
                    pmc_cas_premorbid_datetime_of_contact_1:
                      this.datePipe.transform(
                        this.getFollowupData
                          .pmc_cas_premorbid_datetime_of_contact[i],
                        'MM/dd/yyyy HH:mm:ss'
                      ),
                  });
                } else if (i == 1) {
                  this.form.patchValue({
                    pmc_cas_premorbid_datetime_of_contact_2:
                      this.datePipe.transform(
                        this.getFollowupData
                          .pmc_cas_premorbid_datetime_of_contact[i],
                        'MM/dd/yyyy HH:mm:ss'
                      ),
                  });
                } else if (i == 2) {
                  this.form.patchValue({
                    pmc_cas_premorbid_datetime_of_contact_3:
                      this.datePipe.transform(
                        this.getFollowupData
                          .pmc_cas_premorbid_datetime_of_contact[i],
                        'MM/dd/yyyy HH:mm:ss'
                      ),
                  });
                } else {
                  this.form.patchValue({
                    pmc_cas_premorbid_datetime_of_contact_4:
                      this.datePipe.transform(
                        this.getFollowupData
                          .pmc_cas_premorbid_datetime_of_contact[i],
                        'MM/dd/yyyy HH:mm:ss'
                      ),
                  });
                }
              } else {
                this.form.patchValue({
                  pmc_cas_premorbid_datetime_of_contact_1: '',
                  pmc_cas_premorbid_datetime_of_contact_2: '',
                  pmc_cas_premorbid_datetime_of_contact_3: '',
                  pmc_cas_premorbid_datetime_of_contact_4: '',
                });
              }

              if (i == 0) {
                this.form.patchValue({
                  pmc_cas_premorbid_completedby_1:
                    this.getFollowupData.pmc_cas_premorbid_completedby[i],
                });
                this.userID_1 = this.UId;
              } else if (i == 1) {
                this.form.patchValue({
                  pmc_cas_premorbid_completedby_2:
                    this.getFollowupData.pmc_cas_premorbid_completedby[i],
                });
                this.userID_2 = this.UId;
              } else if (i == 2) {
                this.form.patchValue({
                  pmc_cas_premorbid_completedby_3:
                    this.getFollowupData.pmc_cas_premorbid_completedby[i],
                });
                this.userID_3 = this.UId;
              } else {
                this.form.patchValue({
                  pmc_cas_premorbid_completedby_4:
                    this.getFollowupData.pmc_cas_premorbid_completedby[i],
                });
                this.userID_4 = this.UId;
              }

              if (i == 0) {
                this.form.patchValue({
                  pmc_cas_premorbid_spokewith_1:
                    this.getFollowupData.pmc_cas_premorbid_spokewith[i],
                });
              } else if (i == 1) {
                this.form.patchValue({
                  pmc_cas_premorbid_spokewith_2:
                    this.getFollowupData.pmc_cas_premorbid_spokewith[i],
                });
              } else if (i == 2) {
                this.form.patchValue({
                  pmc_cas_premorbid_spokewith_3:
                    this.getFollowupData.pmc_cas_premorbid_spokewith[i],
                });
              } else {
                this.form.patchValue({
                  pmc_cas_premorbid_spokewith_4:
                    this.getFollowupData.pmc_cas_premorbid_spokewith[i],
                });
              }

              if (i == 0) {
                this.form.patchValue({
                  pmc_cas_premorbid_comments_1:
                    this.getFollowupData.pmc_cas_premorbid_comments[i],
                });
              } else if (i == 1) {
                this.form.patchValue({
                  pmc_cas_premorbid_comments_2:
                    this.getFollowupData.pmc_cas_premorbid_comments[i],
                });
              } else if (i == 2) {
                this.form.patchValue({
                  pmc_cas_premorbid_comments_3:
                    this.getFollowupData.pmc_cas_premorbid_comments[i],
                });
              } else {
                this.form.patchValue({
                  pmc_cas_premorbid_comments_4:
                    this.getFollowupData.pmc_cas_premorbid_comments[i],
                });
              }
            }
          }
          // if (this.getFollowupData.pmc_cas_premorbid_completedby.length == 0) {

          //     this.form.patchValue({
          //       pmc_cas_premorbid_datetime_of_contact_1:
          //         ''
          //     });
          //     this.form.patchValue({
          //       pmc_cas_premorbid_datetime_of_contact_2:
          //         ''
          //     });
          //     this.form.patchValue({
          //       pmc_cas_premorbid_datetime_of_contact_3:
          //         ''
          //     });
          //     this.form.patchValue({
          //       pmc_cas_premorbid_datetime_of_contact_4:
          //         ''
          //     });
          // }
          if (this.getFollowupData.pmc_cas_willing_todo_interview == 1) {
            this.pmc_cas_willing_todo_interview_bool = true;
          } else if (this.getFollowupData.pmc_cas_willing_todo_interview == 2) {
            this.pmc_cas_willing_todo_interview_bool = false;
          } else {
            this.pmc_cas_willing_todo_interview_bool = false;
          }
          if (
            this.getFollowupDataForCaseValues
              .cas_premorbid_approved_for_quote == true
          ) {
            this.cas_premorbid_approved_for_quote_bool = true;
          } else {
            this.cas_premorbid_approved_for_quote_bool = false;
          }
          this.showProgressSpinner = false;
        },
        error: (err: any) => {},
      })
    );

    this.isDisabled();
  }

  saveFollowUpData(event: any) {
    this.onClickDisable = true;
    if (
      this.form.value.pmc_cas_premorbid_completedby_1 != '' &&
      this.form.value.pmc_cas_premorbid_completedby_1 != null
    ) {
      this.userID_1 = this.UId;
    }
    if (
      this.form.value.pmc_cas_premorbid_completedby_2 != '' &&
      this.form.value.pmc_cas_premorbid_completedby_2 != null
    ) {
      this.userID_2 = this.UId;
    }
    if (
      this.form.value.pmc_cas_premorbid_completedby_3 != '' &&
      this.form.value.pmc_cas_premorbid_completedby_3 != null
    ) {
      this.userID_3 = this.UId;
    }
    if (
      this.form.value.pmc_cas_premorbid_completedby_4 != '' &&
      this.form.value.pmc_cas_premorbid_completedby_4 != null
    ) {
      this.userID_4 = this.UId;
    }
    this.form.patchValue({
      pmc_cas_premorbid_datetime_of_contact: [
        this.form.value.pmc_cas_premorbid_datetime_of_contact_1,
        this.form.value.pmc_cas_premorbid_datetime_of_contact_2,
        this.form.value.pmc_cas_premorbid_datetime_of_contact_3,
        this.form.value.pmc_cas_premorbid_datetime_of_contact_4,
      ],
      pmc_cas_premorbid_spokewith: [
        this.form.value.pmc_cas_premorbid_spokewith_1,
        this.form.value.pmc_cas_premorbid_spokewith_2,
        this.form.value.pmc_cas_premorbid_spokewith_3,
        this.form.value.pmc_cas_premorbid_spokewith_4,
      ],
      pmc_cas_premorbid_comments: [
        this.form.value.pmc_cas_premorbid_comments_1,
        this.form.value.pmc_cas_premorbid_comments_2,
        this.form.value.pmc_cas_premorbid_comments_3,
        this.form.value.pmc_cas_premorbid_comments_4,
      ],
      pmc_cas_premorbid_completedby: [
        this.form.value.pmc_cas_premorbid_completedby_1,
        this.form.value.pmc_cas_premorbid_completedby_2,
        this.form.value.pmc_cas_premorbid_completedby_3,
        this.form.value.pmc_cas_premorbid_completedby_4,
      ],
      pmc_cas_premorbid_completedby_ID: [
        this.userID_1,
        this.userID_2,
        this.userID_3,
        this.userID_4,
      ],
    });

    this.showProgressSpinner = true;
    this.subscription.push(
      this.measureService
        .SaveFollowUpData(this.caseKey, this.form.value)
        .subscribe({
          next: (res: any) => {
            if (event == 'save') {
              if (res.Message == 'Success') {
                this.messageService.add({
                  key: 'save',
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Follow Up Data Added Successfuly',
                });
                this.showProgressSpinner = false;
                this.onClickDisable = false;
              }
            } else {
              if (res.Message == 'Success') {
                this.messageService.add({
                  key: 'save',
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Follow Up Data Added Successfuly',
                });
                this.showProgressSpinner = false;
              }
              this.EditScreenBool = false;
              this.onClickDisable = false;
            }
          },
          error: (err: any) => {},
        })
    );
  }
  unCancelCase() {
    this.onClickDisable = true;
    this.showProgressSpinner = true;
    this.subscription.push(
      this.measureService.UnCancelCase(this.caseKey).subscribe({
        next: (res: any) => {
          if (res.msg == 'success') {
            this.EditScreenBool = false;
            this.showProgressSpinner = false;
            this.onClickDisable = false;
            this.messageService.add({
              key: 'cancleCase',
              severity: 'success',
              summary: 'Success',
              detail: 'Case Cancle Successfuly',
            });
          }
        },
        error: (err: any) => {},
      })
    );
  }

  setDateAndTimeDynamically(panelValue: any) {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    this.currentDate = mm + '/' + dd + '/' + yyyy;
    this.currentTime =
      today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    this.currentDate = this.currentDate.concat(' ').concat(this.currentTime);
    if (panelValue == 'reviewedOn') {
      this.form.controls['cas_premorbid_completed_date'].setValue(
        this.currentDate
      );
      this.ReviewOnEst = true;
    }
    if (panelValue == 'dateAndTimeOfContact_1') {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_1'].setValue(
        this.currentDate
      );
    }
    if (panelValue == 'dateAndTimeOfContact_2') {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_2'].setValue(
        this.currentDate
      );
    }
    if (panelValue == 'dateAndTimeOfContact_3') {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_3'].setValue(
        this.currentDate
      );
    }
    if (panelValue == 'dateAndTimeOfContact_4') {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_4'].setValue(
        this.currentDate
      );
    }
  }

  applyFilterGlobal($event: any, stringVal: any) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt!.filterGlobal(inputValue, stringVal);
    if (inputValue !== '') {
      this.crossSearchBool = true;
    } else {
      this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.searchField = '';
    this.getAllCases('', false);
  }

  createForm() {
    this.form = this.fb.group({
      cas_premorbid_symptoms: '',
      cas_premorbid_completed_by: [''],
      cas_premorbid_completed_date: [''],
      pmc_cas_premorbid_patient_phone: '',
      pmc_cas_patient_satisfaction_video_experience: '',
      pmc_cas_patient_satisfaction_communication: '',
      pmc_cas_patient_satisfaction_overall: '',
      pmc_cas_willing_todo_interview: '',
      cas_premorbid_symptoms_text: '',
      cas_premorbid_fac_satisfaction_notes: '',
      cas_premorbid_fac_contact_name: '',
      cas_premorbid_approved_for_quote: '',
      pmc_cas_consent_sent: '',
      pmc_cas_consent_received: '',
      pmc_cas_final_attempt: [false],

      pmc_cas_premorbid_datetime_of_contact: '',
      pmc_cas_premorbid_datetime_of_contact_1: '',
      pmc_cas_premorbid_datetime_of_contact_2: '',
      pmc_cas_premorbid_datetime_of_contact_3: '',
      pmc_cas_premorbid_datetime_of_contact_4: '',
      pmc_cas_premorbid_spokewith: '',
      pmc_cas_premorbid_spokewith_1: '',
      pmc_cas_premorbid_spokewith_2: '',
      pmc_cas_premorbid_spokewith_3: '',
      pmc_cas_premorbid_spokewith_4: '',
      pmc_cas_premorbid_comments: '',
      pmc_cas_premorbid_comments_1: '',
      pmc_cas_premorbid_comments_2: '',
      pmc_cas_premorbid_comments_3: '',
      pmc_cas_premorbid_comments_4: '',
      pmc_cas_premorbid_successful_or_unsuccessful_first: '',
      pmc_cas_premorbid_successful_or_unsuccessful_second: '',
      pmc_cas_premorbid_successful_or_unsuccessful_third: '',
      pmc_cas_premorbid_successful_or_unsuccessful_fourth: '',
      pmc_cas_premorbid_completedby: '',
      pmc_cas_premorbid_completedby_1: '',
      pmc_cas_premorbid_completedby_2: '',
      pmc_cas_premorbid_completedby_3: '',
      pmc_cas_premorbid_completedby_4: '',
      pmc_cas_premorbid_completedby_ID: '',
      cas_premorbid_contact_person_name: '',
    });
  }

  get f() {
    return this.form.controls;
  }

  advanceSearchForm() {
    this.advanceFormSearch = this.fb.group({
      cas_case_number: [''],
      // cas_case_type:[],
      cas_patient: [''],
      selectedTeleneuro_QPS: [],
      cas_advance_date: [''],
      selectedFacility: [],
      CASEIdentificatinNumber: [''],
      folowUp: [],
      selectedPhysicion: [],
      cas_eAlert: [],
      work_flow_type: [],
    });
  }

  ClickFinalAttempt() {
    this.thirdUnsuccessfull = !this.thirdUnsuccessfull;
    this.form.patchValue({
      pmc_cas_final_attempt: this.thirdUnsuccessfull ? true : false,
      pmc_cas_premorbid_successful_or_unsuccessful_fourth: null,
      pmc_cas_premorbid_completedby_4: '',
      pmc_cas_premorbid_datetime_of_contact_4: '',
      pmc_cas_premorbid_spokewith_4: '',
      pmc_cas_premorbid_comments_4: '',
    });
  }

  addCorrespondenceRecord(value: any) {
    const userName = this.userName;

    switch (value) {
      case 'first Completed':
      case 'first close':
        this.firstUnsuccessfull = true;
        this.secondUnsuccessfull = true;
        this.form.controls['pmc_cas_premorbid_completedby_1'].setValue(
          userName
        );
        break;

      case 'first Unsuccessfull':
        this.firstUnsuccessfull = false;
        this.form.controls['pmc_cas_premorbid_completedby_1'].setValue(
          userName
        );
        break;

      case 'Second Completed':
      case 'Second Close':
        this.secondUnsuccessfull = true;
        this.form.controls['pmc_cas_premorbid_completedby_2'].setValue(
          userName
        );
        break;

      case 'Second Unsuccessfull':
        this.secondUnsuccessfull = false;
        this.form.controls['pmc_cas_premorbid_completedby_2'].setValue(
          userName
        );
        break;

      case 'Third Completed':
      case 'Third Unsuccessfull':
      case 'Third Close':
        this.form.controls['pmc_cas_premorbid_completedby_3'].setValue(
          userName
        );
        break;

      case 'Fourth Completed':
      case 'Fourth Unsuccessful':
        this.form.controls['pmc_cas_premorbid_completedby_4'].setValue(
          userName
        );
        break;

      default:
        break;
    }

    if (
      ['first Completed', 'first close', 'first Unsuccessfull'].includes(value)
    ) {
      this.form.patchValue({
        pmc_cas_premorbid_datetime_of_contact_2: '',
        pmc_cas_premorbid_datetime_of_contact_3: '',
        pmc_cas_premorbid_spokewith_2: '',
        pmc_cas_premorbid_spokewith_3: '',
        pmc_cas_premorbid_comments_2: '',
        pmc_cas_premorbid_comments_3: '',
        pmc_cas_premorbid_successful_or_unsuccessful_second: '',
        pmc_cas_premorbid_successful_or_unsuccessful_third: '',
        pmc_cas_premorbid_completedby_2: '',
        pmc_cas_premorbid_completedby_3: '',
      });
    }
    if (
      ['Second Completed', 'Second Close', 'Second Unsuccessfull'].includes(
        value
      )
    ) {
      this.form.patchValue({
        pmc_cas_premorbid_datetime_of_contact_3: '',
        pmc_cas_premorbid_spokewith_3: '',
        pmc_cas_premorbid_comments_3: '',
        pmc_cas_premorbid_successful_or_unsuccessful_third: '',
        pmc_cas_premorbid_completedby_3: '',
      });
    }
  }
  showContactPersonName(val: any) {
    if (val == 'true') {
      this.cas_premorbid_approved_for_quote_bool = true;
    } else {
      this.cas_premorbid_approved_for_quote_bool = false;
      this.form.patchValue({ cas_premorbid_contact_person_name: '' });
    }
  }
  showConsentSentReceived(val: any) {
    if (val == 'yes') {
      this.pmc_cas_willing_todo_interview_bool = true;
    } else {
      this.pmc_cas_willing_todo_interview_bool = false;
      this.form.patchValue({
        pmc_cas_consent_sent: '',
        pmc_cas_consent_received: '',
      });
    }
  }
  isDisabled() {
    if (this.caseStatus == 140) {
      this.form.controls['cas_premorbid_completed_date'].disable();
    } else {
      this.form.controls['cas_premorbid_completed_date'].enable();
    }
    if (this.caseStatus == 140) {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_1'].disable();
    } else {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_1'].enable();
    }
    if (this.caseStatus == 140) {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_2'].disable();
    } else {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_2'].enable();
    }
    if (this.caseStatus == 140) {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_3'].disable();
    } else {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_3'].enable();
    }
    if (this.caseStatus == 140) {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_4'].disable();
    } else {
      this.form.controls['pmc_cas_premorbid_datetime_of_contact_4'].enable();
    }
    if (this.caseStatus == 140) {
      this.showSaveBool = true;
    } else {
      this.showSaveBool = false;
    }
  }

  backTocasesList(data: any) {
    this.showToast = true;
    if (data == 'backTocasesList') {
      this.EditScreenBool = false;
      this.showToast = false;
    } else {
      this.messageService.clear();
      this.messageService.add({
        key: 'c',
        sticky: true,
        severity: 'custom',
        summary: 'Are you sure you want to close out of this page?',
      });
    }
  }
  onConfirm() {
    this.showToast = false;
    this.EditScreenBool = false;
    this.messageService.clear();
  }

  onReject() {
    this.showToast = false;
    this.messageService.clear();
  }
  load(index: any) {
    this.loading[index] = true;
    setTimeout(() => (this.loading[index] = false), 1000);
  }

  AdvanceSearch() {
    this.advanceFormSearch.reset();
    this.advanceSearchModal = true;
  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    });
  }

  exportExcel() {
    this.excelBool = true;
    this.checkEmptyFields();
    this.exportExcelLoader = true;
    let newArray: any = [];
    let cases: any = [];
    this.subscription.push(
      this.analyzeService
        .getAllCases(this.RoleName, this.UId, this.data)
        .subscribe({
          next: (res: any) => {
            if (res.data.length == 0) {
              this.noRecordBool = true;
            } else {
              this.noRecordBool = false;
            }
            if (res) {
              cases = res.data;
              if (cases.length > 0) {
                cases.forEach((item: any) => {
                  item.CASEIdentificationTYPE =
                    item?.CASEIdentificationTYPE?.concat(':').concat(
                      item?.CASEIdentificatinNumber != null
                        ? item?.CASEIdentificatinNumber
                        : 'N/A'
                    );
                  let caseStatus = this.statusList.filter((x: any) => {
                    return x.value == item.CaseStatus;
                  });
                  if (caseStatus.length > 0) {
                    item.caseStatusLabel = caseStatus[0].name;
                  }
                  let time: any;
                  if (item.CaseStartTime) {
                    time = this.datePipe.transform(
                      item.CaseStartTime,
                      'MM/dd/yyyy hh:mm:ss'
                    );
                  }

                  newArray.push({
                    CASENumber: item.CASENumber,
                    cas_is_audio_consult: item.cas_is_audio_consult
                      ? 'Yes'
                      : 'No',
                    CASEIdentificatinNumber: item.CASEIdentificatinNumber,
                    FacilityName: item.FacilityName,
                    PatientDOB: new Date(item.PatientDOB).toLocaleDateString(
                      'en-US'
                    ),
                    cas_metric_tpa_consult: item.cas_metric_tpa_consult
                      ? 'Yes'
                      : 'No',
                    caseStatusLabel: item.caseStatusLabel,
                    QPSReviewCompleted:
                      (item.caseStatusLabel === 'Stroke Alert' ||
                        item.caseStatusLabel === 'Stroke Alert') &&
                      item.QPSReviewCompleted == 1
                        ? 'Yes'
                        : '',
                    CASEIdentificationTYPE: item.CASEIdentificationTYPE,
                    PhysicianName: item.PhysicianName,
                    CaseStartTime: time,
                    CaseType: item.CaseType,
                    PatientName: item.PatientName,
                  });
                });
              }

              let dataForExcel: any = [];
              let workbook = new Workbook();
              let worksheet = workbook.addWorksheet('Sheet1', {
                properties: {
                  tabColor: { argb: '36286B' },
                  outlineLevelRow: 1,
                },
              });
              worksheet.columns = [
                { header: 'Case No', key: 'case no', width: 15 },
                { header: 'AudioOnly', key: 'AudioOnly', width: 15 },
                { header: 'Patient ID ', key: 'Patient ID', width: 15 },
                { header: 'Facility', key: 'Facility', width: 90 },
                { header: 'Patient DOB', key: 'Patient DOB', width: 90 },
                {
                  header: 'Lytic Candidate',
                  key: 'Lytic Candidate',
                  width: 90,
                },
                { header: 'Case Status', key: 'Case Status', width: 20 },
                {
                  header: 'QPS Review Completed',
                  key: 'QPS Review Completed',
                  width: 20,
                },
                { header: 'Identifier', key: 'Identifier', width: 30 },
                { header: 'Physician', key: 'Physician ', width: 25 },
                { header: 'Start time', key: 'Start time', width: 25 },
                { header: 'Type', key: 'Type', width: 20 },
                { header: 'Patient name', key: 'Patient name', width: 25 },
              ];
              worksheet.eachRow(
                { includeEmpty: true },
                function (row, rowNumber) {
                  row.eachCell((cell, number) => {
                    cell.fill = {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: { argb: '767C88' },
                      bgColor: { argb: '' },
                    };
                    cell.font = {
                      bold: true,
                      color: { argb: 'FFFFFF' },
                      size: 12,
                    };
                  });
                }
              );

              if (this.roleForFacility) {
                worksheet.getColumn('Case Status').hidden = true;
                worksheet.getColumn('QPS Review Completed').hidden = true;
              }
              newArray.forEach((element: any) => {
                dataForExcel.push(Object.values(element));
              });

              dataForExcel.forEach((d: any) => {
                let row = worksheet.addRow(d);
              });
              this.excelDownload(workbook, 'Case Follow Up');
              this.exportExcelLoader = false;
            }
          },
          error: (err: any) => {},
        })
    );
  }

  validateInput(input: any): any {
    const regex = /\d/; // Regular expression to match any numeric character

    if (regex.test(input.key)) {
      return false;
    }
    return true;
  }

  onContextMenu(event: MouseEvent, cases: any, bool: any) {
    event.preventDefault();
    const queryParams = {
      getCaseDetail: true,
      editScreen: true,
      caseKey: cases.CaseKey,
      caseStatus: cases.CaseStatus,
      caseStartTime: cases.CaseStartTime,
      screenStatus: bool,
      SelectedCaseEdit: JSON.stringify(cases),
    };
    const navigationExtras: NavigationExtras = {
      queryParams,
    };
    const url = this.router.createUrlTree(
      ['Home/Measures/Measures'],
      navigationExtras
    );
    window.open(url.toString(), '_blank');
  }
  onlyNumbers: any = '/^d+$/';

  onContextMenuPreventDefault(event: any) {
    event.preventDefault();
  }

  ngOnDestroy() {
    if (this.subscription.length != 0) {
      this.subscription.forEach((i: any) => {
        i.unsubscribe();
      });
    }

    Object.getOwnPropertyNames(this)
      .filter((propName) => Array.isArray((<any>this)[propName]))
      .forEach((propName) => ((<any>this)[propName] = []));
  }
}
